import {GET, POST} from "@/services/gateway";

const getStats = (data) => {
  const currentDate = new Date();
  data = {
    ...data,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  }
  return POST('dashboard/stats/microsoft', data)
}

const getEntraStats = (data) => {
  const currentDate = new Date();
  data = {
    ...data,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  }
  return POST('entra-id/stats', data)
}

const getFinishedBackup = () => {
  return GET('dashboard/microsoft/ready')
}

export {
  getStats,
  getEntraStats,
  getFinishedBackup
}
